/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Turnstile_FailedInputs */

const en_error_turnstile_failed = /** @type {(inputs: Error_Turnstile_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't confirm you're a person. Complete the check and try again.`)
};

/**
* | output |
* | --- |
* | "We couldn't confirm you're a person. Complete the check and try again." |
*
* @param {Error_Turnstile_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_turnstile_failed = /** @type {((inputs?: Error_Turnstile_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Turnstile_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_turnstile_failed(inputs)
});